// Mixin global para filtros en Vue 3
import { formatMoney, formatOfficialMoney, formatPercent, formatNumber, formatDate } from '@/utils/filters'

export default {
  methods: {
    // Filtro de dinero usando la moneda oficial del sistema (recomendado)
    $money(value, decimals = 2) {
      return formatMoney(value, null, decimals) // null = usar moneda oficial
    },

    // Filtro de dinero con moneda personalizada
    $moneyCustom(value, currency, decimals = 2) {
      return formatMoney(value, currency, decimals)
    },

    // Filtro explícito para moneda oficial del sistema
    $officialMoney(value, decimals = 2) {
      return formatOfficialMoney(value, decimals)
    },

    // Filtro de porcentaje
    $percent(value, decimals = 2) {
      return formatPercent(value, decimals)
    },

    // Filtro de número
    $number(value, decimals = 0) {
      return formatNumber(value, decimals)
    },

    // Filtro de fecha
    $date(value, format = 'DD/MM/YYYY') {
      return formatDate(value, format)
    },

    // Método helper para formatear precios específicamente en colones (legacy)
    $colones(value) {
      return formatMoney(value, '₡')
    },

    // Método helper para formatear precios en dólares (legacy)
    $dollars(value) {
      return formatMoney(value, '$')
    },

    // Obtener la moneda oficial actual del sistema
    $getOfficialCurrency() {
      try {
        // Intentar desde sessionStorage/localStorage (más eficiente)
        const sysconf = JSON.parse(sessionStorage.getItem('sysconf') || '{}')
        if (sysconf && sysconf.official_currency) {
          return sysconf.official_currency
        }

        const sysconfLocal = JSON.parse(localStorage.getItem('sysconf') || '{}')
        if (sysconfLocal && sysconfLocal.official_currency) {
          return sysconfLocal.official_currency
        }
        
        return '₡' // fallback final
      } catch (error) {
        console.warn('Error al obtener official_currency:', error)
        return '₡'
      }
    }
  },

  // También agregar como computed properties para usar en templates
  computed: {
    $filters() {
      return {
        money: this.$money,
        moneyCustom: this.$moneyCustom,
        officialMoney: this.$officialMoney,
        percent: this.$percent,
        number: this.$number,
        date: this.$date,
        colones: this.$colones,
        dollars: this.$dollars
      }
    },

    // Computed property para obtener la moneda oficial reactivamente
    $officialCurrency() {
      return this.$getOfficialCurrency()
    }
  }
}